import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NzCarouselComponent } from "ng-zorro-antd/carousel";
import { AppService } from "src/app/app.service";
import {
  faLessThan,
  faGreaterThan,
  faExpandArrowsAlt,
} from "@fortawesome/free-solid-svg-icons";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import dayjs from "dayjs";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import {
  VAIconRegistryService,
  greaterThan,
  lessThan,
} from "@va/core-library/icons";

@Component({
  selector: "app-xl-chart-carousel",
  templateUrl: "./xl-chart-carousel.component.html",
  styleUrls: ["./xl-chart-carousel.component.scss"],
  host: { class: "xl-chart-component" },
  encapsulation: ViewEncapsulation.None,
})
export class XLChartCarouselComponent implements OnInit {
  tickerDetails: any = {};
  lineItem: any = {};
  chartType: string;
  dataSet: boolean;
  dataToUse: any;
  chartSubType: string;
  defaultData: any;
  originalPeriod: any;
  chartList: any[] = [];
  selectedValue: string;
  beginningStateReferrer: string;
  effect = "scrollx";
  faLessThan = faLessThan;
  faGreaterThan = faGreaterThan;
  faExpandArrowsAlt = faExpandArrowsAlt;
  @ViewChild(NzCarouselComponent)
  chartCarousel: NzCarouselComponent;
  logSwitch: boolean;
  displayData: any = {};
  displayDataSet = false;
  chartPopupType: string;
  chartPopupDataToUse: any;
  feature = "XL_PAGE";
  apiEP: string = window.apiUrl;
  isStockPriceChecked = false;
  hasAccessToStockPrice = false;
  showDistribution = true;
  showForRollingPeriods = true;
  showRevision = true;
  stockPriceData = {
    "revision-daily": undefined,
    "revision-monthly": undefined,
  };
  dateFormatPattern = "DD MMM YYYY";
  constructor(
    private appService: AppService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([lessThan, greaterThan]);
  }

  ngOnInit() {
    this.chartType = "revision-monthly";
    this.beginningStateReferrer = "Chart_Revision_Monthly";
    const queryParams = this.route.snapshot.queryParams;
    let source = "consensus";
    const selectedSourceList = [source];
    if (queryParams) {
      this.tickerDetails = {
        name: queryParams.companyFullName,
        ticker: queryParams.ticker,
      };
      this.lineItem = {
        dapparameterid: queryParams.dpid,
        line_item_name: queryParams.line_name,
        current_quarter: queryParams.current_quarter,
        period: queryParams.period,
        cut: queryParams.cut,
        pgCode: queryParams.pgCode,
        estimatePeriod: queryParams.estimatePeriod,
        interimPeriod: queryParams.interimPeriod,
      };
      source = queryParams.source;
      if (source.toLowerCase() !== "consensus")
        selectedSourceList.push(source.toLowerCase());
    }
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.hasAccessToStockPrice = data.hasMarketDataAccess;
      });
    this.dataSet = false;
    this.getSourceList().subscribe((resp: any) => {
      const sourcesList = resp.data.map(function (n) {
        return {
          label: n.name,
          value: n.name,
          checked: selectedSourceList.includes(n.name.toLowerCase()),
        };
      });
      this.setDefaults(sourcesList, source);
      this.dataSet = true;
      setTimeout(() => {
        const slideIndex = this.chartList.indexOf(this.selectedValue);
        this.chartCarousel.goTo(Number(slideIndex));
      }, 100);
    });
  }

  getSourceList() {
    const ticker = this.tickerDetails.ticker;
    return this.http.get(`${this.apiEP}/addin/get_source_info_by_ticker}`, {
      params: {
        ticker,
      },
    });
  }

  setDefaults(sourceList, selectedSource) {
    //update this function to fit XL carousel
    this.dataToUse = {
      companyFullName: this.tickerDetails.name,
      period: this.lineItem.period,
      source: selectedSource,
      forecast: true,
      cut: this.lineItem.cut,
      isPeers: false,
      gAdjust: "implied",
      dapparamId: this.lineItem.dapparameterid,
      ticker: this.tickerDetails.ticker,
      export: true,
      currentQuarter: this.lineItem.current_quarter,
      sourceList: sourceList,
    };
    const sourceListHasConsensus =
      this.dataToUse.sourceList &&
      this.dataToUse.sourceList.findIndex((s) => {
        return s.value.toLowerCase() === "consensus";
      }) !== -1;
    this.dataToUse.selectedRevisionSources = [this.dataToUse.source];
    if (
      this.dataToUse.source &&
      this.dataToUse.source.toLowerCase() !== "consensus" &&
      this.dataToUse.source.toLowerCase() !== "va actuals"
    ) {
      this.dataToUse.selectedRevisionSources.push("Consensus");
    }
    if (sourceListHasConsensus === true) {
      this.dataToUse.revisionSourceList = {
        headerText: "Source",
        list: [
          { label: "High Broker", value: "High", checked: false },
          { label: "Low Broker", value: "Low", checked: false },
        ].concat(this.dataToUse.sourceList),
      };
    } else {
      this.dataToUse.revisionSourceList = {
        headerText: "Source",
        list: [
          { label: "Consensus", value: "Consensus", checked: true },
          { label: "High Broker", value: "High", checked: false },
          { label: "Low Broker", value: "Low", checked: false },
        ].concat(this.dataToUse.sourceList),
      };
    }
    this.defaultData = {
      ...this.dataToUse,
      showRevisionSourceList: false,
      showSurpriseSourceList: false,
      peersList: {
        headerText: "Peers",
        list: this.dataToUse.peersList || [],
      },
      showPeersList: false,
      displayDataSet: false,
    };
    this.originalPeriod = this.lineItem.period;

    this.chartSubType = "monthly";
    const rollingPeriods = ["ltm", "ntm", "stm"];
    const restrictedForDistribution: boolean =
      this.dataToUse.source &&
      (this.dataToUse.source.toLowerCase() !== "consensus" ||
        rollingPeriods.includes(this.dataToUse.period.toLowerCase()) ||
        this.dataToUse.period.toLowerCase().includes("c"));

    const restrictedForRollingPeriods: boolean =
      this.dataToUse.source &&
      rollingPeriods.includes(this.dataToUse.period.toLowerCase());

    const restrictedForRevision: boolean =
      this.dataToUse.period.toLowerCase().includes("c") &&
      this.dataToUse.source.toLowerCase() !== "filings" &&
      this.lineItem.interimPeriod === "false" &&
      ((this.dataToUse.source.toLowerCase() === "consensus" &&
        this.lineItem.estimatePeriod === "false") ||
        (this.dataToUse.source.toLowerCase() === "va actuals" &&
          this.lineItem.estimatePeriod === "true" &&
          this.lineItem.pgCode === "VR"));

    this.showDistribution = !restrictedForDistribution;
    this.showForRollingPeriods = !restrictedForRollingPeriods;
    this.showRevision = !restrictedForRevision;

    if (this.showDistribution) {
      this.chartList.push("distribution-analysis");
    }
    if (this.showForRollingPeriods) {
      this.chartList.push("trend-bar");
    }
    if (this.showRevision) {
      this.chartList.push("revision-monthly");
      if (this.showForRollingPeriods) {
        this.chartList.push("revision-daily");
      }
    }

    if (this.chartType.indexOf("-") !== -1) {
      const obj = this.chartType.split("-");
      this.chartType = obj[0].toLowerCase();
      this.chartSubType = obj[1].toLowerCase();
    }
    this.selectedValue = `${this.chartType.toLowerCase()}-${this.chartSubType.toLowerCase()}`;
    const extraData = {
      period: this.lineItem.period,
      line_id: this.lineItem.dapparameterid.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
      addinClientType: "addinweb",
    };
    this.appService.logUserAction(
      {},
      this.tickerDetails.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Open",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }
  getFeatureName(selectedVal: string) {
    let featureName = "";
    switch (selectedVal) {
      case "distribution-analysis":
        featureName = "Chart_Distribution_Waterfall";
        break;
      case "trend-bar":
        featureName = "Chart_Trends_Bar";
        break;
      case "revision-daily":
        featureName = "Chart_Revisions_Source_DailyLTM";
        break;
      case "revision-monthly":
        featureName = "Chart_Revisions_Source_Monthly2Y";
        break;
      default:
        featureName = "";
    }
    return featureName;
  }
  onChartTypeChange() {
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];
    const slideIndex = this.chartList.indexOf(this.selectedValue);
    this.logSwitch = true;
    this.chartCarousel.goTo(Number(slideIndex));
  }
  carouselChange(index) {
    if (index >= this.chartList.length) {
      index = 0;
    }
    if (index < 0) {
      index = this.chartList.length - 1;
    }
    this.selectedValue = this.chartList[index];
    this.defaultData.showRevisionSourceList = false;
    if (
      this.dataToUse.sourceList &&
      this.dataToUse.revisionSourceList.list.length > 1 &&
      (this.selectedValue === "revision-daily" ||
        this.selectedValue === "revision-monthly")
    ) {
      this.defaultData.showRevisionSourceList = true;
    }
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];

    // flag to distinguish between actual chart switch and false chart switch triggered on component load.
    if (this.logSwitch === true) {
      this.logChartSwitch();
    }
  }
  /**
   * It sets the stock price revision data emitted from chart plotter
   * @param {{'revision-daily': any, 'revision-monthly': any}} data - stock price daily and monthly data
   */
  setPriceStockData(data) {
    if (data) {
      const dailyRevisionStock = data["revision-daily"]
        ? data["revision-daily"].data
        : undefined;
      const monthlyRevisionStock = data["revision-monthly"]
        ? data["revision-monthly"].data
        : undefined;
      if (dailyRevisionStock) {
        this.stockPriceData = {
          ...this.stockPriceData,
          "revision-daily": {
            ...dailyRevisionStock,
            last_date: dailyRevisionStock.last_date
              ? dayjs(dailyRevisionStock.last_date).format(
                  this.dateFormatPattern,
                )
              : "-",
          },
        };
      }
      if (monthlyRevisionStock) {
        this.stockPriceData = {
          ...this.stockPriceData,
          "revision-monthly": {
            ...monthlyRevisionStock,
            last_date: monthlyRevisionStock.last_date
              ? dayjs(monthlyRevisionStock.last_date).format(
                  this.dateFormatPattern,
                )
              : "-",
          },
        };
      }
    } else {
      this.stockPriceData = {
        "revision-daily": undefined,
        "revision-monthly": undefined,
      };
    }
  }
  logChartSwitch() {
    this.logSwitch = false;
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Switch",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }

  prevChart() {
    this.logSwitch = true;
    this.chartCarousel.pre();
  }
  nextChart() {
    this.logSwitch = true;
    this.chartCarousel.next();
  }
  setFocus(event) {
    event.currentTarget.querySelector(".slick-dots-bottom").focus();
  }
  setDisplayData(data) {
    this.displayData = {
      ...this.displayData,
      ...data,
    };
    this.setChartDisplayDetails();
    // if (window.parent) {
    //   window.parent.postMessage(
    //     { message: "setHeightAuto", value: true },
    //     "*"
    //   );
    // }
    this.displayDataSet = true;
  }
  chartSubTypeDisplay = "";
  setChartDisplayDetails() {
    let displayPeriod = this.defaultData.period;
    let xData = "",
      startDate = "",
      endDate = "";
    switch (this.selectedValue) {
      case "trend-bar":
        this.chartSubTypeDisplay = "bar chart";
        xData = this.displayData.tableData.Value.x;
        startDate = xData[0];
        endDate = xData[xData.length - 1];
        displayPeriod = `${startDate} to ${endDate}`;
        break;
      case "distribution-analysis":
        this.chartSubTypeDisplay = "analysis";
        break;
      case "revision-daily":
        this.chartSubTypeDisplay = "daily - 1 year";
        break;
      case "revision-monthly":
        this.chartSubTypeDisplay = "monthly - 2 year";
        break;

      default:
        this.chartSubTypeDisplay = this.chartSubType;
        displayPeriod = ` - ${displayPeriod}`;
    }
    this.displayData.period = displayPeriod;
  }
  revisionSourceChange(event) {
    this.dataToUse = {
      ...this.dataToUse,
      selectedRevisionSources: event,
    };
  }
  exportAddinCallback($event) {
    const postObj = {
      chart: this.selectedValue,
      data: $event,
    };
    if ($event.isPngExport) {
      window.parent.postMessage(
        { message: "exportPNGChart", value: JSON.stringify($event.data) },
        "*",
      );
    } else {
      if (this.isStockPriceChecked) {
        postObj.data = {
          ...$event,
          stockPriceData: this.stockPriceData[this.selectedValue],
        };
      }
      window.parent.postMessage(
        { message: "exportChart", value: JSON.stringify(postObj) },
        "*",
      );
    }
  }
}
